module.exports = __webpack_public_path__ + "static/img/lightning.b227070.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lightning.png
// module id = Xjax
// module chunks = 7